import React, { useState, useEffect } from "react";

import { format } from "date-fns";

import {
  HStack,
  VStack,
  Divider,
  Flex,
  Text,
  Box,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";

import Information from "../../../ServicosAcolhimento/Visualizar/Information";

import FamiliaAcolhedoraSAService from "../../../../../main/services/FamiliaAcolhedoraSAService";
import { cpf, mascaraNumeroGuia } from "../../../../utils/masks";
import CriancaService from "../../../../../main/services/CriancaService";
import MovimentacaoService from "../../../../../main/services/MovimentacaoService";
import { IconeDownload } from "../../../../components/IconeDownload";
import { BsThreeDots } from "react-icons/bs";
import {
  Permission,
  vrCriancaFunc,
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../../../helpers/Funcionalidades";
import { FiEdit } from "react-icons/fi";
import { useAuthProvider } from "../../../../../Context/AuthProvider";
import { CgClose } from "react-icons/cg";
import Swal from "sweetalert2";
import { useAppContext } from "../../../../../Context/MessageContextProvider";

export const Step = ({
  step,
  movimentacao,
  idCrianca,
  data,
  print,
  movimentacaoAnterior,
  isLast,
  onOpenCadastrar,
  setIntercalada,
  isFirst,
  setLoadingPainel,
  setLoadingHistorico,
  setLoadingCadastro,
}) => {
  const { roleKeycloack, user } = useAuthProvider();
  const {
    setMovimentacaoData,
    setMovimentacaoDataAnterior,
    setMovimentacaoDataPosterior,
    setMovimentacaoEditar,
    idPJ,
    setMovimentacaoIsFirst,
  } = useAppContext();
  const gestor = roleKeycloack?.includes(criancaFunc.visualizarTudo);
  const ministerioPublico = roleKeycloack?.includes(
    servicoAcolhimentoFunc.visualizarParteMP
  );
  const tribunalJustica = roleKeycloack?.includes(
    servicoAcolhimentoFunc.visualizarParteTJ
  );

  const ppcaam = roleKeycloack?.includes(
    servicoAcolhimentoFunc.visualizarPartePPCAAM
  );
  const [disabledMPTJ, setDisabledMPTJ] = useState(false);
  const [orgaoMPTJ, setOrgaoMPTJ] = useState(false);

  useEffect(() => {
    const idOrgaoMovimentacao =
      movimentacao?.idOrgaoExterno || movimentacao?.idOrgao;

    const usuarioPossuiOrgaoExteno = user?.orgaoExterno?.includes(
      Number(idOrgaoMovimentacao)
    );
    const usuarioPossuiOrgao = user?.orgaos?.some(
      (orgao) => orgao.id === idOrgaoMovimentacao
    );

    const usuarioMPServicoPromotoria = user?.orgaos?.some(
      (orgao) => orgao.id === movimentacao?.servicoAcolhimento?.promotoria?.id
    );

    setOrgaoMPTJ(usuarioPossuiOrgao);
    setDisabledMPTJ(
      ((ministerioPublico || tribunalJustica) && !isFirst) ||
        ((ministerioPublico || tribunalJustica) &&
          isFirst &&
          !usuarioPossuiOrgao &&
          !usuarioPossuiOrgaoExteno) ||
        (ministerioPublico && isFirst && !usuarioMPServicoPromotoria)
    );
  }, [
    isFirst,
    ministerioPublico,
    movimentacao?.idOrgao,
    movimentacao?.idOrgaoExterno,
    movimentacao?.servicoAcolhimento?.promotoria?.id,
    tribunalJustica,
    user?.orgaoExterno,
    user?.orgaos,
  ]);

  const getTermoGuarda = (idServicoAcolhimento, cpfFormated, idCrianca) => {
    FamiliaAcolhedoraSAService.getFamiliaAcolhedoraTermoGuarda(
      idServicoAcolhimento,
      cpfFormated,
      idCrianca
    )
      .then((res) => {
        const downloadUrl = res.config.url;
        window.open(downloadUrl, "_blank");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getAnexoGuia = (id, opcao) => {
    CriancaService.getAnexo(id, opcao)
      .then((res) => {
        if (opcao === "download") {
          const downloadUrl = res.config.url;
          window.open(downloadUrl, "_blank");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const messageMovimentacao = (messageEntrega, messageRestricao) => {
    Swal.fire({
      title: "Atenção!",
      text: messageRestricao
        ? "Existe visita, restrição ou ocorrência cadastradas no período informado."
        : messageEntrega
        ? "Existe processo/procedimento associado a entrega voluntária."
        : "",
      icon: "warning",
      confirmButtonText: "Fechar",
      confirmButtonColor: "#169499",
    });
  };

  const messageDeleteMovimentacao = (
    messageEntrega,
    messageRestricao,
    messageProcedimento
  ) => {
    if (messageEntrega || messageRestricao) {
      messageMovimentacao(messageEntrega, messageRestricao);
    } else {
      Swal.fire({
        title: "Atenção!",
        text: `${
          messageProcedimento
            ? "Ao excluir, o processo/procedimento será descompartilhado com o irmão, não sendo mais permitida a alimentação simultânea e a Promotoria com atribuição será atualizada. Deseja prosseguir?"
            : "Ao excluir, todas as informações e eventuais documentos anexados a esse movimento serão excluídos. Deseja continuar?"
        }`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          MovimentacaoService.deleteMovimentacao(idCrianca, movimentacao.id)
            .then((res) => {
              setLoadingPainel(true);
              setLoadingHistorico(true);
              setLoadingCadastro(true);
              Swal.fire({
                title: "Sucesso!",
                text: "Sucesso! Registro Excluído.",
                icon: "success",
                confirmButtonText: "Continuar",
                confirmButtonColor: "#169499",
              }).then((result) => {});
            })
            .catch((error) => {
              console.log(error.response.data);
              Swal.fire({
                title: "Atenção!",
                text: error.response.data.message
                  ? error.response.data.message
                  : "",
                icon: "error",
                confirmButtonText: "Fechar",
                confirmButtonColor: "#169499",
              });
            });
        }
      });
    }
  };

  return (
    <HStack mt="20px">
      <VStack w="50px" position="relative" mb={"-5px"} mt={10}>
        {!isLast && (
          <Divider
            position="absolute"
            top="100%"
            left="50%"
            height="calc(100% + 65px)"
            orientation="vertical"
            width="3px"
            transform="translate(-50%)"
            bgColor={print ? "#C4C4C4" : "#E8E4E4"}
          />
        )}
        <Flex
          bg="#C4C4C4"
          borderRadius="50%"
          boxSize="32px"
          justifyContent="center"
          alignItems="center"
          mt={10}
        >
          <Text
            color="#000000"
            fontWeight={700}
            size="16px"
            lineHeight="21.6px"
          >
            {step}
          </Text>
        </Flex>
        <Divider
          orientation="vertical"
          width="3px"
          h={print ? "10px" : "120px"}
          bgColor={print ? "#C4C4C4" : "#E8E4E4"}
        />
      </VStack>
      <VStack
        border={"solid 1px"}
        borderRadius={"3xl"}
        flex={1}
        bg="#F6F6F6"
        px={{ base: "10px", sm: "40px" }}
        py={{ base: "10px", sm: "25px" }}
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Flex flexDirection="row" justifyContent={"space-between"} w={"100%"}>
          <Box>
            <Text
              fontWeight={700}
              fontSize="16px"
              lineHeight="21.6px"
              color={"#169499"}
            >
              {" "}
              MOVIMENTO{" "}
            </Text>
          </Box>
          {!print &&
            ((isFirst &&
              ppcaam &&
              movimentacao?.motivoSituacao?.riscoVida === "S") ||
            (isFirst &&
              (roleKeycloack.includes(vrCriancaFunc.movimentoEditar) ||
                ((roleKeycloack?.includes(
                  criancaFunc.visualizarTudoAcolhimento
                ) ||
                  roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
                  user?.orgaoExterno?.includes(Number(idPJ))))) ||
            gestor ||
            (ministerioPublico &&
              (![2, 5].includes(movimentacao?.movimento?.id) ||
                !disabledMPTJ)) ||
            (orgaoMPTJ && isFirst) ||
            (tribunalJustica &&
              (![2, 5].includes(movimentacao?.movimento?.id) ||
                (orgaoMPTJ && isFirst) ||
                !disabledMPTJ)) ? (
              <Box>
                <Box position="relative">
                  <Text as="b" color="black" fontSize={"md"}>
                    Opções:
                  </Text>
                </Box>
              </Box>
            ) : null)}
        </Flex>
        {!print && (
          <Flex
            justifyContent="space-between"
            gap={{ base: "10px", md: "60px" }}
            w="100%"
            //flexDirection={{ base: `${print ? "row" : "column"}`, md: "row" }}
            alignItems={{ base: "flex-start", md: "center" }}
          >
            <Information
              print={print}
              mt="0px"
              title="Data:"
              information={
                movimentacao?.dataMovimentacao
                  ? format(movimentacao?.dataMovimentacao, "dd/MM/yyyy")
                  : ""
              }
            />
            <Information
              print={print}
              mt="0px"
              title="Situação:"
              information={
                movimentacao?.movimento?.tipoSituacao?.descricao ||
                movimentacao?.motivoSituacao?.tipoSituacao?.descricao ||
                movimentacao?.movimentoMovimentacao?.tipoSituacaoMovimentacao
                  ?.descricao
              }
            />

            <HStack
              alignItems="center"
              justifyContent="end"
              gap={"10px"}
              w="100%"
            />
            <Flex justifyContent="center">
              {(isFirst &&
                ppcaam &&
                movimentacao?.motivoSituacao?.riscoVida === "S") ||
              (isFirst &&
                (roleKeycloack.includes(vrCriancaFunc.movimentoEditar) ||
                  ((roleKeycloack?.includes(
                    criancaFunc.visualizarTudoAcolhimento
                  ) ||
                    roleKeycloack?.includes(
                      criancaFunc.visualizarTudoTutelar
                    )) &&
                    user?.orgaoExterno?.includes(Number(idPJ))))) ||
              gestor ||
              (ministerioPublico &&
                (![2, 5].includes(movimentacao?.movimento?.id) ||
                  (orgaoMPTJ && isFirst) ||
                  !disabledMPTJ)) ||
              (tribunalJustica &&
                (![2, 5].includes(movimentacao?.movimento?.id) ||
                  (orgaoMPTJ && isFirst) ||
                  !disabledMPTJ)) ? (
                <Menu>
                  <MenuButton
                    as={IconButton}
                    icon={<BsThreeDots color="#fff" fontSize="20px" />}
                    variant={"link"}
                    cursor={"pointer"}
                    backgroundColor="#95BCBF"
                    rounded={100}
                    p={2}
                  />
                  <MenuList>
                    {roleKeycloack.includes(vrCriancaFunc.movimentoEditar) ||
                    ((roleKeycloack?.includes(
                      criancaFunc.visualizarTudoAcolhimento
                    ) ||
                      roleKeycloack?.includes(
                        criancaFunc.visualizarTudoTutelar
                      )) &&
                      user?.orgaoExterno?.includes(Number(idPJ))) ||
                    (ppcaam &&
                      isFirst &&
                      movimentacao?.motivoSituacao?.riscoVida === "S") ||
                    (ministerioPublico &&
                      (![2, 5].includes(movimentacao?.movimento?.id) ||
                        (orgaoMPTJ && isFirst) ||
                        !disabledMPTJ)) ||
                    (tribunalJustica &&
                      (![2, 5].includes(movimentacao?.movimento?.id) ||
                        (orgaoMPTJ && isFirst) ||
                        !disabledMPTJ)) ? (
                      <MenuItem
                        p={2}
                        color={"#374BCE"}
                        onClick={() => {
                          setMovimentacaoData(movimentacao);
                          setMovimentacaoDataAnterior(
                            data[movimentacaoAnterior + 1]
                          );
                          setMovimentacaoDataPosterior(
                            data[movimentacaoAnterior - 1]
                          );
                          setMovimentacaoEditar(true);
                          setMovimentacaoIsFirst(isFirst);

                          onOpenCadastrar();
                          setIntercalada(false);
                        }}
                      >
                        <FiEdit />
                        <Text ml="5px">Editar</Text>
                      </MenuItem>
                    ) : (
                      ""
                    )}

                    {isFirst && data && data.length > 1 ? (
                      <Permission
                        roleKeycloack={roleKeycloack}
                        func={vrCriancaFunc.movimentoExcluir}
                      >
                        <MenuItem
                          p={2}
                          color={"red.500"}
                          onClick={() => {
                            messageDeleteMovimentacao(
                              movimentacao?.possuiEntregaVoluntaria,
                              movimentacao?.possuiVisitaRestricaoOcorrencia,
                              movimentacao?.processoCompartilhadoIrmao
                            );
                          }}
                        >
                          <CgClose />
                          <Text ml="5px">Excluir</Text>
                        </MenuItem>
                      </Permission>
                    ) : null}
                  </MenuList>
                </Menu>
              ) : null}
            </Flex>
          </Flex>
        )}
        <Information
          print={print}
          mt="0px"
          title="Movimento:"
          information={
            movimentacao
              ? movimentacao.motivoSituacao?.tipoSituacao.descricao ===
                "Acolhido"
                ? movimentacao?.movimento?.descricao ||
                  "Entrada por Acolhimento"
                : movimentacao.motivoSituacao?.tipoSituacao.descricao ===
                    "Desligado" && !movimentacao.movimento?.descricao
                ? "Saída por Desligamento"
                : movimentacao.motivoSituacao?.tipoSituacao.descricao ===
                  "Pendennte"
                ? "Pendente por Maioridade"
                : `${
                    movimentacao.movimento?.descricao ||
                    movimentacao.movimentoMovimentacao?.descricao
                  }`
              : ""
          }
        />
        {(movimentacao?.movimento || movimentacao?.movimentoMovimentacao) &&
        (movimentacao?.movimento?.id === 2 ||
          movimentacao?.movimento?.id === 5 ||
          movimentacao?.movimento?.id === 6 ||
          movimentacao?.movimentoMovimentacao?.id === 2 ||
          movimentacao?.movimentoMovimentacao?.id === 5 ||
          movimentacao?.movimentoMovimentacao?.id === 6) ? (
          <Information
            print={print}
            title="Justificativa:"
            information={
              movimentacao
                ? movimentacao.justificativa?.descricao ||
                  movimentacao?.movimentoMovimentacao?.justificativa?.descricao
                : ""
            }
          />
        ) : (
          ""
        )}
        {movimentacao.motivoSituacao?.tipoSituacao.descricao === "Acolhido" ||
        movimentacao.motivoSituacao?.tipoSituacao.descricao === "Desligado" ? (
          <Information
            print={print}
            title="Motivo:"
            information={
              movimentacao ? movimentacao.motivoSituacao?.descricao : ""
            }
          />
        ) : (
          ""
        )}
        {movimentacao?.tipoMovimentacao === "ENTRADA" &&
          movimentacao.incluidoProgramaPPCAAM && (
            <Information
              zIndex={0}
              print={print}
              hintText={
                "O Programa de Proteção a Crianças e Adolescentes Ameaçados de Morte - PPCAAM, consiste em uma política de proteção à vida de crianças e adolescentes em ameaça iminente de morte."
              }
              title="Está Incluído no PPCAAM?"
              information={
                movimentacao.incluidoProgramaPPCAAM === "S"
                  ? "Sim"
                  : movimentacao.incluidoProgramaPPCAAM === "N"
                  ? "Não"
                  : ""
              }
            />
          )}
        {movimentacao?.movimento?.id !== 6 &&
          movimentacao?.movimentoMovimentacao?.id !== 6 && (
            <Information
              print={print}
              title="Serviço de Acolhimento:"
              information={
                movimentacao
                  ? movimentacao?.servicoAcolhimento?.nomeFantasia
                  : ""
              }
            />
          )}
        {(movimentacao?.movimento?.id === 1 ||
          movimentacao?.movimentoMovimentacao?.id === 1) && (
          <Information
            print={print}
            title="Há Nova Guia:"
            information={
              movimentacao?.existeNovaGuiaAcolhimento === "S" ? "Sim" : "Não"
            }
          />
        )}
        <Flex
          gap={{ base: "10px", lg: "100px" }}
          flexDirection={{ base: `${print ? "row" : "column"}`, lg: "row" }}
          alignItems={{ base: "flex-start", md: "center" }}
        >
          {(movimentacao?.movimento?.tipoSituacao?.descricao === "Acolhido" ||
            movimentacao?.motivoSituacao?.tipoSituacao?.descricao ===
              "Acolhido" ||
            movimentacao?.motivoSituacao?.tipoSituacao?.descricao ===
              "Desligado" ||
            movimentacao?.movimento?.tipoSituacao?.descricao === "Desligado" ||
            movimentacao?.movimentoMovimentacao?.tipoSituacaoMovimentacao
              ?.descricao === "Acolhido" ||
            movimentacao?.movimentoMovimentacao?.tipoSituacaoMovimentacao
              ?.descricao === "Desligado") &&
          movimentacao?.movimento?.id !== 2 &&
          movimentacao?.movimentoMovimentacao?.id !== 2 &&
          movimentacao?.movimento?.id !== 6 &&
          movimentacao?.movimentoMovimentacao?.id !== 6 ? (
            <Information
              print={print}
              mt="0px"
              title="Número da Guia:"
              information={
                movimentacao.numeroGuia
                  ? mascaraNumeroGuia(movimentacao.numeroGuia)
                  : ""
              }
            />
          ) : (
            ""
          )}

          <HStack
            alignItems="center"
            justifyContent="end"
            gap={"10px"}
            w="100%"
          >
            {(movimentacao?.movimento?.id === 5 ||
              movimentacao?.movimentoMovimentacao?.id === 5) &&
              movimentacao?.justificativa?.id === 2 && (
                <Information
                  print={print}
                  mt="0px"
                  title={`${
                    (movimentacao?.movimento &&
                      movimentacao?.movimento?.tipoSituacao?.descricao !==
                        "Acolhido" &&
                      movimentacao?.movimento?.tipoSituacao?.descricao !==
                        "Desligado") ||
                    (movimentacao?.movimentoMovimentacao &&
                      movimentacao?.movimentoMovimentacao
                        .tipoSituacaoMovimentacao?.descricao !== "Acolhido" &&
                      movimentacao?.movimentoMovimentacao
                        .tipoSituacaoMovimentacao?.descricao !== "Desligado")
                      ? "Baixar Decisão:"
                      : "Baixar Guia:"
                  }`}
                />
              )}

            {movimentacao?.movimento?.id !== 2 &&
              movimentacao?.movimentoMovimentacao?.id !== 2 &&
              movimentacao?.movimento?.id !== 5 &&
              movimentacao?.movimentoMovimentacao?.id !== 5 &&
              movimentacao?.movimento?.id !== 6 &&
              movimentacao?.movimentoMovimentacao?.id !== 6 && (
                <Information
                  print={print}
                  mt="0px"
                  title={`${
                    (movimentacao?.movimento ||
                      movimentacao?.movimentoMovimentacao) &&
                    movimentacao?.movimento?.tipoSituacao?.descricao !==
                      "Acolhido" &&
                    movimentacao?.movimentoMovimentacao
                      ?.tipoSituacaoMovimentacao?.descricao !== "Acolhido" &&
                    movimentacao?.movimentoMovimentacao
                      ?.tipoSituacaoMovimentacao?.descricao !== "Desligado" &&
                    movimentacao?.movimento?.tipoSituacao?.descricao !==
                      "Desligado"
                      ? "Baixar Decisão:"
                      : "Baixar Guia:"
                  }`}
                />
              )}

            {movimentacao && movimentacao?.anexoGuia === true ? (
              <button
                onClick={() =>
                  getAnexoGuia(movimentacao.idAnexoGuiaMovimentacao, "download")
                }
              >
                <IconeDownload />
              </button>
            ) : (
              ""
            )}
          </HStack>
        </Flex>
        <Information
          print={print}
          title="Informações Complementares:"
          information={
            movimentacao ? movimentacao.informacoesComplementares : ""
          }
        />
        <Box />
        {!!movimentacao.familiaAcolhedora &&
        (movimentacao?.movimento?.tipoSituacao?.descricao === "Acolhido" ||
          movimentacao?.motivoSituacao?.tipoSituacao?.descricao ===
            "Acolhido" ||
          movimentacao?.movimentoMovimentacao?.tipoSituacaoMovimentacao
            ?.descricao === "Acolhido") ? (
          <>
            <Divider
              borderColor="#DDEBEA"
              orientation="horizontal"
              mt="20px"
              borderWidth="1px"
            />
            <Information
              print={print}
              title="Dados do Acolhedor"
              information={""}
            />
            <Information
              print={print}
              title="Identificação:"
              information={
                movimentacao?.familiaAcolhedora?.nome ||
                movimentacao?.familiaAcolhedora?.cpf
                  ? `${movimentacao?.familiaAcolhedora?.nome} - CPF: ${cpf(
                      movimentacao?.familiaAcolhedora?.cpf
                    )}`
                  : ""
              }
            />
            <Information
              print={print}
              title="Data de Nascimento:"
              information={
                movimentacao.familiaAcolhedora.dataNascimento
                  ? format(
                      movimentacao.familiaAcolhedora.dataNascimento,
                      "dd/MM/yyyy"
                    )
                  : ""
              }
            />
            <Information
              print={print}
              title="Gênero:"
              information={
                movimentacao.familiaAcolhedora.genero
                  ? movimentacao.familiaAcolhedora.genero
                  : ""
              }
            />
            <Information
              print={print}
              title="Bairro:"
              information={
                movimentacao.familiaAcolhedora.bairro
                  ? movimentacao.familiaAcolhedora.bairro
                  : ""
              }
            />
            <Flex
              gap={{ base: "10px", md: "60px" }}
              flexDirection={{ base: `${print ? "row" : "column"}`, lg: "row" }}
              alignItems={{ base: "flex-end", md: "end" }}
            >
              <Information
                print={print}
                title="Fim da Validade do Termo de Guarda:"
                information={
                  movimentacao.familiaAcolhedora.validadeTermoGuarda
                    ? format(
                        movimentacao.familiaAcolhedora.validadeTermoGuarda,
                        "dd/MM/yyyy"
                      )
                    : ""
                }
              />
              <HStack
                alignItems="end"
                justifyContent="end"
                gap={"10px"}
                w="100%"
              >
                {movimentacao.familiaAcolhedora ||
                ((movimentacao?.movimento?.id === 2 ||
                  movimentacao?.movimentoMovimentacao?.id === 2) &&
                  movimentacao?.motivoSituacao?.tipoSituacao?.descricao ===
                    "Acolhido") ? (
                  <>
                    <Information
                      print={print}
                      mt="0px"
                      title="Baixar Termo de Guarda:"
                    />
                    {!!movimentacao?.familiaAcolhedora &&
                    movimentacao?.familiaAcolhedora?.termoGuarda === true ? (
                      <button
                        onClick={() =>
                          getTermoGuarda(
                            movimentacao?.servicoAcolhimento?.id,
                            movimentacao?.familiaAcolhedora?.cpf,
                            idCrianca
                          )
                        }
                      >
                        <IconeDownload />
                      </button>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}
              </HStack>
            </Flex>
          </>
        ) : (
          ""
        )}
      </VStack>
    </HStack>
  );
};
